/**
 * As leituras propostas das imagens de documento do material, na pré-análise (E123.F3).
 *
 * E114.F3 punha a leitura proposta no cartão da candidata, na etapa fotográfica. Com a etapa fora
 * da esteira, o perito confirma aqui, na seção das fotografias, sem abrir a troca: a do verso
 * materializado (E122.F3) e a de cada imagem de documento do material, com a mesma confirmação
 * de antes (`LeituraPropostaDaImagem`).
 *
 * E205.F4 (ADR-0147 §2.5): na mesa, a leitura de cada imagem se confirma na linha do documento, na
 * aba Documentos (`LinhaDeDocumento`); este bloco fica para a seção das fotografias fora da mesa.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { CandidatasDoCasoData } from '@/lib/candidatas_de_imagem';

import { LeituraPropostaDaImagem } from './LeituraPropostaDaImagem';

const t = ptBR.analiseFotografica.candidatas.leitura;

export interface LeiturasDoMaterialProps {
  caseId: string;
  candidatas: CandidatasDoCasoData;
  concluido: boolean;
  onConfirmada: () => void;
}

export function LeiturasDoMaterial({
  caseId,
  candidatas,
  concluido,
  onConfirmada,
}: LeiturasDoMaterialProps): JSX.Element | null {
  const leituras = candidatas.leituras ?? [];
  if (leituras.length === 0) return null;
  return (
    <section className="space-y-sc-3" data-testid="leituras-do-material">
      <h4 className="text-body text-fg">{t.titulo}</h4>
      <ul className="space-y-sc-3">
        {leituras.map((leitura) => (
          <li key={leitura.documento_id} className="border border-border p-sc-3">
            <p className="truncate text-body-sm text-fg-muted">{leitura.documento_nome}</p>
            <LeituraPropostaDaImagem
              caseId={caseId}
              leitura={leitura}
              bloqueado={concluido}
              onConfirmada={onConfirmada}
            />
          </li>
        ))}
      </ul>
    </section>
  );
}
